export default class TemplateMetadata {
    template;
    _captionDimensions;
    _sermonClipStyles;
    constructor(template) {
        this.template = template;
        this.init();
    }
    get info() {
        return {
            captionDimensions: this._captionDimensions,
            sermonClipStyles: this._sermonClipStyles
        };
    }
    init() {
        this.buildCaptionDimensions();
        this.cacheStyles();
    }
    cacheSermonClipStyles() {
        const sermonClipEl = this.template.querySelector('[data-amelement="sermonclip"]');
        let containerStyles = {};
        let videoStyles = {};
        if (sermonClipEl) {
            const video = sermonClipEl.querySelector('video');
            if (video) {
                videoStyles = video.style;
            }
            containerStyles = sermonClipEl.style;
            this._sermonClipStyles = {
                videoStyles,
                containerStyles
            };
        }
    }
    cacheStyles() {
        this.cacheSermonClipStyles();
    }
    buildCaptionDimensions() {
        const caption = this.template.querySelector('[data-amelement="caption"]') || null;
        if (!caption) {
            this._captionDimensions = {
                width: 0,
                height: 0
            };
            return;
        }
        const copyBlock = caption.cloneNode(true);
        document.body.appendChild(copyBlock);
        if (caption) {
            copyBlock.style.transform = '';
            const clientRect = copyBlock.getBoundingClientRect();
            const dimensions = {
                height: clientRect.height,
                width: clientRect.width
            };
            copyBlock.remove();
            this._captionDimensions = dimensions;
        }
    }
    recomputeTemplateDimensions() {
        this.buildCaptionDimensions();
    }
}
